import { Contact } from "@/components/jobs/SubmitJob";
import { SUBMIT_JOB_CONTENT } from "@/utilities/Constants";
import { createSlice } from "@reduxjs/toolkit";

const initialState: Record<string, number | string | boolean | Array<string> | Array<Contact> | Record<string, any>> = {
  // Job Profile details
  contacts: [],
  garaSign: "",
  exception: "",
  upi2: "",
  displayName: "",
  buildNumber: "",
  upgradeCode: "",
  updateType: "",
  releaseDate: "",
  milestone: "",
  milestoneNumber: "",
  localizationFile: "",
  localizedContentUrl: "",
  shortDescription: "",
  longDescription: "",
  releaseNotFile: "",
  releaseNoteUrl: "",
  downloadFiles: [],
  installFiles: [],
  releaseState: "",
  forcedValidation: false,
  targetingList: [],
  whereUsedTargets: [],
  plc: "",
  publisher: "",
  platform: "",
  releaseId: "",
  releaseType: "",
  release: "",
  targetableBuildNumbers: [],
  engines: {}
};

const submitReleaseSlice = createSlice({
  name: "submitRelease",
  initialState: initialState,
  reducers: {
    updateSubmitReleaseDetails: (state, action: { payload: { key: string; value: string | boolean | Array<any> | Record<string, any> } }) => {
      state[action.payload.key] = action.payload.value;
    },
    updateSubmitReleaseContactDetails: (state, action: { payload: Array<Contact> }) => {
      state.contacts = action.payload;
    },
    resetSubmitRelease: (): Record<string, number | string | boolean | Array<string> | Array<Contact> | Record<string, any>> => {
      return {
        ...initialState
      };
    }
  }
});

export const { updateSubmitReleaseDetails, updateSubmitReleaseContactDetails, resetSubmitRelease } = submitReleaseSlice.actions;

export default submitReleaseSlice.reducer;
